import { PlusCircleFilled } from "@ant-design/icons";
import { Tag } from "antd";
import { FC, Key, useEffect, useState } from "react";

import { PersonnelScopeModal } from "../personnel-scope-modal";
import { SelectItemType } from "../personnel-scope-modal/use-store";
import styles from "./create-tutorial.module.less";
import { IPersonnelScopeInputProps } from "./types";

export const PersonnelScopeInput: FC<IPersonnelScopeInputProps> = ({
  value,
  onChange,
}) => {
  const [scope, setScope] = useState<SelectItemType[]>([]);

  const [open, setOpen] = useState(false);

  const openModal = () => {
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
  };

  const updateScope = (nodes: SelectItemType[]) => {
    setScope(nodes);
    triggerChange(nodes);
    closeModal();
  };

  const removeScope = (key: Key) => {
    const newNode = scope.filter((item) => item.key !== key);

    setScope(newNode);
    triggerChange(newNode);
  };

  const triggerChange = (changedValue: SelectItemType[]) => {
    onChange?.(changedValue);
  };

  useEffect(() => {
    value && setScope(value);
  }, [value]);

  return (
    <div className={styles["personnel-scope"]}>
      <div className={styles["personnel-scope-input"]}>
        {(value || scope).map((item) => {
          return (
            <Tag
              key={item.key}
              closable
              className={styles["tap-item"]}
              onClose={() => removeScope(item.key)}
            >
              {item.name}
            </Tag>
          );
        })}
      </div>
      <PlusCircleFilled
        style={{ fontSize: "24px", color: "#475aec" }}
        onClick={openModal}
      />
      {open && (
        <PersonnelScopeModal
          defaultCheckedNodes={value || scope}
          open={open}
          onCancel={closeModal}
          onOk={updateScope}
        />
      )}
    </div>
  );
};
